export default {"src":"/_next/static/media/apple.8a7b50c1.svg","height":512,"width":384,"blurWidth":0,"blurHeight":0};